const NORMAL_PARAM = 10

module.exports = NORMAL_PARAM
